import { apiClient } from '../utils/apiClient';

export function getPushPublicKey() {
  return apiClient.get(`/push-subscriptions/public-key`);
}

export function subscribePush({ body }: { body: any }) {
  return apiClient.post(`/push-subscriptions`, { ...body });
}

export function unsubscribePush({ endpoint }: { endpoint: string }) {
  return apiClient.delete(`/push-subscriptions`, { data: { endpoint } });
}

export function sendTestPush() {
  return apiClient.post(`/push-subscriptions/test`);
}
